'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const Tokens = require('@zapier/design-tokens');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const Tokens__default = /*#__PURE__*/_interopDefault(Tokens);

const Colors = {
  GrayWarm1: Tokens__default.default.GrayWarm1,
  GrayWarm2: Tokens__default.default.GrayWarm2,
  GrayWarm3: Tokens__default.default.GrayWarm3,
  GrayWarm4: Tokens__default.default.GrayWarm4,
  GrayWarm5: Tokens__default.default.GrayWarm5,
  GrayWarm6: Tokens__default.default.GrayWarm6,
  GrayWarm7: Tokens__default.default.GrayWarm7,
  GrayWarm8: Tokens__default.default.GrayWarm8,
  GrayWarm9: Tokens__default.default.GrayWarm9,
  GrayWarm10: Tokens__default.default.GrayWarm10,
  BrandOrange: Tokens__default.default.BrandOrange,
  BrandEarth: Tokens__default.default.BrandEarth,
  BrandLavender: Tokens__default.default.BrandLavender,
  BrandNight: Tokens__default.default.BrandNight,
  BrandAlmostWhite: Tokens__default.default.BrandAlmostWhite,
  BrandPeach: Tokens__default.default.BrandPeach,
  BrandCream: Tokens__default.default.BrandCream,
  BrandBolt: Tokens__default.default.BrandBolt,
  BrandSky: Tokens__default.default.BrandSky,
  BrandMoss: Tokens__default.default.BrandMoss,
  Purple1: Tokens__default.default.ColorPurple1,
  Purple2: Tokens__default.default.ColorPurple2,
  Purple3: Tokens__default.default.ColorPurple3,
  Purple4: Tokens__default.default.ColorPurple4,
  Purple5: Tokens__default.default.ColorPurple5,
  Yellow1: Tokens__default.default.ColorYellow1,
  Yellow2: Tokens__default.default.ColorYellow2,
  Yellow3: Tokens__default.default.ColorYellow3,
  Yellow4: Tokens__default.default.ColorYellow4,
  Yellow5: Tokens__default.default.ColorYellow5,
  Red1: Tokens__default.default.ColorRed1,
  Red2: Tokens__default.default.ColorRed2,
  Red3: Tokens__default.default.ColorRed3,
  Red4: Tokens__default.default.ColorRed4,
  Red5: Tokens__default.default.ColorRed5,
  Blue1: Tokens__default.default.ColorBlue1,
  Blue2: Tokens__default.default.ColorBlue2,
  Blue3: Tokens__default.default.ColorBlue3,
  Blue4: Tokens__default.default.ColorBlue4,
  Blue5: Tokens__default.default.ColorBlue5,
  Orange1: Tokens__default.default.ColorOrange1,
  Orange2: Tokens__default.default.ColorOrange2,
  Orange3: Tokens__default.default.ColorOrange3,
  Orange4: Tokens__default.default.ColorOrange4,
  Orange5: Tokens__default.default.ColorOrange5,
  Teal1: Tokens__default.default.ColorTeal1,
  Teal2: Tokens__default.default.ColorTeal2,
  Teal3: Tokens__default.default.ColorTeal3,
  Teal4: Tokens__default.default.ColorTeal4,
  Teal5: Tokens__default.default.ColorTeal5,
  Green1: Tokens__default.default.ColorGreen1,
  Green2: Tokens__default.default.ColorGreen2,
  Green3: Tokens__default.default.ColorGreen3,
  Green4: Tokens__default.default.ColorGreen4,
  Green5: Tokens__default.default.ColorGreen5,
  Pink1: Tokens__default.default.ColorPink1,
  Pink2: Tokens__default.default.ColorPink2,
  Pink3: Tokens__default.default.ColorPink3,
  Pink4: Tokens__default.default.ColorPink4,
  Pink5: Tokens__default.default.ColorPink5,
  PrimeWhite: Tokens__default.default.PrimeWhite,
  PrimeBlack: Tokens__default.default.PrimeBlack,
  PrimePurple: Tokens__default.default.PrimePurple,
  PrimeBlue: Tokens__default.default.PrimeBlue,
  PrimeTeal: Tokens__default.default.PrimeTeal,
  PrimeGreen: Tokens__default.default.PrimeGreen,
  PrimeYellow: Tokens__default.default.PrimeYellow,
  PrimeOrange: Tokens__default.default.PrimeOrange,
  PrimeRed: Tokens__default.default.PrimeRed,
  PrimePink: Tokens__default.default.PrimePink,
  UiBrandWeakest: Tokens__default.default.UiBrandWeakest,
  UiBrandWeaker: Tokens__default.default.UiBrandWeaker,
  UiBrand: Tokens__default.default.UiBrand,
  UiBrandStronger: Tokens__default.default.UiBrandStrongest,
  UiBrandStrongest: Tokens__default.default.UiBrandStrongest,
  UiPrimaryWeakest: Tokens__default.default.UiPrimaryWeakest,
  UiPrimaryWeaker: Tokens__default.default.UiPrimaryWeaker,
  UiPrimary: Tokens__default.default.UiPrimary,
  UiPrimaryStronger: Tokens__default.default.UiPrimaryStronger,
  UiPrimaryStrongest: Tokens__default.default.UiPrimaryStrongest,
  StatusWarningWeakest: Tokens__default.default.StatusWarningWeakest,
  StatusWarningWeaker: Tokens__default.default.StatusWarningWeaker,
  StatusWarning: Tokens__default.default.StatusWarning,
  StatusWarningStronger: Tokens__default.default.StatusWarningStronger,
  StatusWarningStrongest: Tokens__default.default.StatusWarningStrongest,
  StatusErrorWeakest: Tokens__default.default.StatusErrorWeakest,
  StatusErrorWeaker: Tokens__default.default.StatusErrorWeaker,
  StatusError: Tokens__default.default.StatusError,
  StatusErrorStronger: Tokens__default.default.StatusErrorStronger,
  StatusErrorStrongest: Tokens__default.default.StatusErrorStrongest,
  StatusSuccessWeakest: Tokens__default.default.StatusSuccessWeakest,
  StatusSuccessWeaker: Tokens__default.default.StatusSuccessWeaker,
  StatusSuccess: Tokens__default.default.StatusSuccess,
  StatusSuccessStronger: Tokens__default.default.StatusSuccessStronger,
  StatusSuccessStrongest: Tokens__default.default.StatusSuccessStrongest,
  BackgroundWeaker: Tokens__default.default.BackgroundWeaker,
  BackgroundDefault: Tokens__default.default.BackgroundDefault,
  BackgroundStronger: Tokens__default.default.BackgroundStronger,
  BackgroundStrongest: Tokens__default.default.BackgroundStrongest,
  BackgroundSelected: Tokens__default.default.BackgroundSelected,
  BackgroundOverlay: Tokens__default.default.BackgroundOverlay,
  StrokeWeaker: Tokens__default.default.StrokeWeaker,
  StrokeDefault: Tokens__default.default.StrokeDefault,
  StrokeStronger: Tokens__default.default.StrokeStronger,
  StrokeSelected: Tokens__default.default.StrokeSelected,
  ReservedBeta: Tokens__default.default.ReservedBeta,
  ReservedInvite: Tokens__default.default.ReservedInvite,
  ReservedFree: Tokens__default.default.ReservedFree,
  TextWeakest: Tokens__default.default.TextWeakest,
  TextWeaker: Tokens__default.default.TextWeaker,
  TextDefault: Tokens__default.default.TextDefault,
  TextStronger: Tokens__default.default.TextStronger,
  TextLink: Tokens__default.default.TextLink,
  TextLinkHover: Tokens__default.default.TextLinkHover,
  TextInverted: Tokens__default.default.TextInverted,
  // special colors
  transparent: "transparent",
  inherit: "inherit",
  currentColor: "currentColor"
};

exports.Colors = Colors;
//# sourceMappingURL=Colors.cjs.js.map
